import { render, staticRenderFns } from "./ToastsPosition.vue?vue&type=template&id=37685a41"
import script from "./ToastsPosition.vue?vue&type=script&lang=js"
export * from "./ToastsPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports